import { request } from '@/api/apiUtils';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { IRoles, IUser, ResponseType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const AUTH_ROOT = ['auth'] as const;

const fetchers = {
    user: {
        key: () => [...AUTH_ROOT, 'user'] as const,
        fetch: async (): Promise<IUser> => {
            const response: ResponseType<IUser> = await request('user');
            return response.data;
        },
    },
    roles: {
        key: () => [...AUTH_ROOT, 'roles'] as const,
        fetch: async (): Promise<IRoles> => {
            const response: ResponseType<IRoles> = await request('roles');
            return response.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const authEntity: EntityDefinition<typeof fetchers> = {
    name: 'auth',
    roots: [AUTH_ROOT],
    fetchers,
};
